import { SxProps, TextField, TextFieldProps, useTheme } from '@mui/material'

const CustomTextField = (props: TextFieldProps) => {
    const theme = useTheme()

    const InputTextSxProps: SxProps = {
        width: '100%',
        maxWidth: '408px',
        borderRadius: '8px',

        '.MuiOutlinedInput-root': {
            height: '60px'
        },

        '.MuiOutlinedInput-root input': {
            height: '100%'
        },

        // ".MuiOutlinedInput-root input::placeholder": {
        //     opacity: 0.7,
        // },

        '.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderRadius: '8px',
            borderColor: theme.palette.text.disabled
        },

        '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus': {
            WebkitBoxShadow: '0 0 0px 1000px transparent inset !important',
            transition: 'background-color 9999s ease-in-out 0s'
        }
    }

    return <TextField size={'medium'} {...props} sx={{ ...InputTextSxProps, ...props.sx }} />
}

export default CustomTextField
